import type { FunctionalComponent } from 'preact';
import type { WidgetBookingPath } from '../types';

interface Props {
  value: WidgetBookingPath;
  onChange: (path: WidgetBookingPath) => void;
  primaryLabel?: string;
  tablesLabel?: string;
}

/**
 * Segmented control: Tickets vs Tables for hybrid events.
 */
export const BookingPathSwitch: FunctionalComponent<Props> = ({
  value,
  onChange,
  primaryLabel = 'Tickets',
  tablesLabel = 'Tables',
}) => (
  <div class="mw-booking-path-switch" role="tablist" aria-label="Choose tickets or table reservation">
    <button
      type="button"
      role="tab"
      class={value === 'tickets' ? 'mw-booking-path-switch__btn is-active' : 'mw-booking-path-switch__btn'}
      aria-selected={value === 'tickets'}
      onClick={() => onChange('tickets')}
    >
      {primaryLabel}
    </button>
    <button
      type="button"
      role="tab"
      class={value === 'tables' ? 'mw-booking-path-switch__btn is-active' : 'mw-booking-path-switch__btn'}
      aria-selected={value === 'tables'}
      onClick={() => onChange('tables')}
    >
      {tablesLabel}
    </button>
  </div>
);
